import classNames from 'classnames';
import { FlexContainer, NoBankAccount } from 'components';
import { observer } from 'mobx-react-lite';
import { usePublicAccount, useTenancy } from 'state';
import { TenantsLinked, TenantsNotLinked } from './bricks';
import styles from './TodoItemLinkTenants.module.scss';

/**
 * TodoItemLinkTenants
 *
 * @return {JSX.Element}
 */
const TodoItemLinkTenants = ({ className, onSuccess }) => {
  const tenancyDoc = useTenancy();
  const publicAccount = usePublicAccount();

  const tenantsLinked = tenancyDoc.tenantsLinked;
  const bankingHasLinked = !!publicAccount.data.banking?.plaidRecipientId;
  // const

  return (
    <FlexContainer
      className={classNames(
        styles.TodoItemLinkTenants,
        className,
        TodoItemLinkTenants.displayName
      )}
      column
      gap
    >
      {tenantsLinked ? (
        <TenantsLinked />
      ) : bankingHasLinked ? (
        <TenantsNotLinked onSuccess={onSuccess} />
      ) : (
        <NoBankAccount />
      )}
    </FlexContainer>
  );
};

TodoItemLinkTenants.displayName = 'TodoItemLinkTenants';

export default observer(TodoItemLinkTenants);
